import React from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Skeleton,
  Stack,
  Typography,
} from '@mui/material';
import { MatchSuggestion } from '@marageti/z4-sdk/lib/travel';
import MatchSuggestionCard from './match-suggestion-card/match-suggestion-card';

type Props = {
  categoryTitle: string;
  defaultExpanded?: boolean;
  isLoading: boolean;
  suggestions: MatchSuggestion[];
};

const Emptylist = () => (
  <Typography color="primary.light">
    There are no available partners in this category.
  </Typography>
);

const MatchSuggestionsSection = ({
  categoryTitle,
  defaultExpanded = false,
  isLoading,
  suggestions,
}: Props) => (
  <Accordion defaultExpanded={defaultExpanded}>
    <AccordionSummary>
      <Typography variant="bodyBold">{`${categoryTitle} (${suggestions.length})`}</Typography>
    </AccordionSummary>
    {isLoading ? (
      <Skeleton variant="rounded" height={242} sx={{ mb: 3 }} />
    ) : (
      <AccordionDetails>
        <Stack spacing={1.5}>
          {suggestions.length === 0 ? (
            <Emptylist />
          ) : (
            suggestions.map((suggestion) => (
              <MatchSuggestionCard
                key={suggestion.partner.id}
                matchSuggestion={suggestion}
              />
            )))}
        </Stack>
      </AccordionDetails>
    )}
  </Accordion>
);

export default MatchSuggestionsSection;
